import { Text } from '@ltvco/refresh-lib/theme';
import { useState } from 'react';

import {
  OralArgumentTranscriptAccordion,
  TranscriptContentBox,
} from './components';

interface OralArgumentTranscriptProps {
  transcript: string | null;
}

export const OralArgumentTranscript = ({
  transcript,
}: OralArgumentTranscriptProps) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <OralArgumentTranscriptAccordion
      display="Transcript"
      expanded={expanded}
      onChange={() => setExpanded((prev) => !prev)}
    >
      <TranscriptContentBox>
        <Text sx={{ lineHeight: 1.5 }}>
          {transcript || 'No transcription available.'}
        </Text>
      </TranscriptContentBox>
    </OralArgumentTranscriptAccordion>
  );
};
